
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class YourMenuComponent extends Vue {
  @Prop(Array) items!: string[];
  @Prop(String)  selectedItem!: string | undefined;
  @Prop(Function) selectItem!: (item: string) => void;
}
